import { FC, MouseEventHandler } from 'react'
import { styled } from '../../../lib/stitches'
import { Row, TooltipIconButton } from '../../core/Components'
import { DetailPageIcon } from '../../core/icons/icons'

export const GLOBAL_PLAYER_TABLET_HEIGHT = '80px'

export const PlayerSection = styled(Row, {
  padding: '0px 16px',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  '@tablet': {
    flex: '1',
    width: 'auto',
    justifyContent: 'start'
  }
})

export const OpenDetailPageButton: FC<{
  onClick: MouseEventHandler<HTMLButtonElement>
  disabled: boolean
}> = ({ onClick, disabled }) => (
  <TooltipIconButton tooltipText="Open Detail Page" onClick={onClick} isDisabled={disabled}>
    <DetailPageIcon width="25px" height="25px" style={{ color: '#141414' }} />
  </TooltipIconButton>
)
